import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { isAuthenticated } from '../../../../services/auth';
import { Avatar, Button, message } from 'antd';
import { UploadOutlined, UserOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { getUser, editUser } from '../../../../services/user';
import UnifiedDashboard from '../../../../components/layout/UnifiedDashboard';
import './EditProfile.css';

const EditProfile = ({ match, hideBackButton = false }) => {
  const history = useHistory();
  const [values, setValues] = useState({
    name: '',
    username: '',
    email: '',
    phone: '',
    photo: null,
    photoUrl: '',
  });

  const { name, username, email, phone, photo, photoUrl } = values;
  const { user, token } = isAuthenticated();

  const loadUser = async () => {
    let data = await getUser(match.params.userId);
    setValues(v => ({
      ...v,
      name: data.data.name,
      username: data.data.username,
      email: data.data.email,
      phone: data.data.phone,
      photoUrl: data.data.photo ? `${process.env.REACT_APP_API?.replace(/\/api$/, '') }${data.data.photo}` : '',
    }));
  };

  useEffect(() => {
    loadUser();
    // eslint-disable-next-line
  }, []);

  const handleChange = (name) => (event) => {
    const value = name === 'photo' ? event.target.files[0] : event.target.value;
    setValues({ ...values, [name]: value, ...(name === 'photo' ? { photoUrl: URL.createObjectURL(value) } : {}) });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let userData = new FormData();
    userData.append('name', name);
    userData.append('username', username);
    userData.append('email', email);
    userData.append('phone', phone);
    userData.append('adminAuth', user.role);
    if (photo) userData.append('photo', photo);
    try {
      await editUser(match.params.userId, userData, token);
      window.location.reload();
      message.success('Perfil atualizado com sucesso', 4);
    } catch (err) {
      if (err.response?.status === 400) message.error(err.response.data, 4);
    }
  };

  const handlePhotoClick = () => {
    document.getElementById('photo-upload').click();
  };

  const editProfileForm = () => (
    <form onSubmit={handleSubmit} className='edit-profile-form'>
      {/* Avatar Section */}
      <div className='edit-profile-avatar-section'>
        <div className='edit-profile-avatar-container'>
          <Avatar
            size={100}
            src={photoUrl}
            icon={<UserOutlined />}
            className='edit-profile-avatar'
          />
          <input
            id='photo-upload'
            type='file'
            accept='image/*'
            className='edit-profile-upload-input'
            onChange={handleChange('photo')}
          />
          <Button 
            icon={<UploadOutlined />} 
            type='default'
            size='small' 
            className='edit-profile-upload-btn'
            onClick={handlePhotoClick}
          />
        </div>
      </div>

      {/* Form Fields */}
      <div className='form-group'>
        <label className='form-label edit-profile-label'>Nome</label>
        <input
          type='text'
          className='form-control shadow-none edit-profile-input'
          placeholder='Digite o nome completo'
          value={name}
          onChange={handleChange('name')}
        />
      </div>

      <div className='form-group'>
        <label className='form-label edit-profile-label'>Nome de usuário</label>
        <input
          type='text'
          className='form-control shadow-none edit-profile-input'
          placeholder='Digite o nome de usuário'
          value={username}
          onChange={handleChange('username')}
        />
      </div>

      <div className='form-group'>
        <label className='form-label edit-profile-label'>E-mail</label>
        <input
          type='email'
          className='form-control shadow-none edit-profile-input'
          placeholder='Digite o e-mail'
          value={email}
          onChange={handleChange('email')}
        />
      </div>

      <div className='form-group'>
        <label className='form-label edit-profile-label'>Telefone</label>
        <input
          type='tel'
          className='form-control shadow-none edit-profile-input'
          placeholder='(00) 00000-0000'
          value={phone}
          onChange={handleChange('phone')}
        />
      </div>

      {/* Submit Button */}
      <div className='edit-profile-submit-container'>
        <Button
          type='primary'
          size='large'
          htmlType='submit'
          className='edit-profile-submit-btn'
        >
          Salvar Alterações
        </Button>
      </div>
    </form>
  );

  return (
    <UnifiedDashboard>
      <div className='edit-profile-container'>
        <div className='edit-profile-header-section'>
          {!hideBackButton && (
            <button 
              className='edit-profile-back-btn-header'
              onClick={() => history.goBack()}
              title="Voltar"
            >
              <ArrowLeftOutlined />
            </button>
          )}
          <h2 className='edit-profile-title'>
            <i className='fas fa-user-edit'></i>
            Editar Perfil
          </h2>
          <p className='edit-profile-subtitle'>Atualize suas informações pessoais</p>
        </div>
        <div className='edit-profile-content-wrapper'>
          {editProfileForm()}
        </div>
      </div>
    </UnifiedDashboard>
  );
};

export default EditProfile;
